var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import ProfilePicture from "../ProfilePicture/ProfilePicture";
const PersonBrief = (_a) => {
    var { person, heading, onNameClick, isSystemPhone, className, badge } = _a, otherProps = __rest(_a, ["person", "heading", "onNameClick", "isSystemPhone", "className", "badge"]);
    return (_jsxs("div", Object.assign({}, otherProps, { className: "media " + (className || ""), children: [_jsx(ProfilePicture, { person: person, showProfilePicture: true, className: "mr-3" }), _jsxs("div", { className: "media-body", children: [heading && _jsx("h6", { className: "media-heading mb-1", children: heading }), _jsxs("div", { className: "d-flex justify-content-between flex-wrap", children: [_jsx("div", { children: _jsx("a", { 
                                    // @ts-expect-error - TS2322 - Type 'string | null' is not assignable to type 'string | undefined'.
                                    href: onNameClick ? "#" : null, onClick: (e) => {
                                        e.preventDefault();
                                        if (onNameClick) {
                                            onNameClick();
                                        }
                                    }, children: person.fullName }) }), badge && (_jsx("div", { children: _jsx("span", { className: "badge badge-success", children: badge }) }))] }), _jsxs("div", { children: [person.phoneNumber, " ", isSystemPhone && (_jsx("span", { className: "badge badge-dark", children: "Text Msg Only" }))] }), person.label && _jsx("div", { className: "text-muted", children: person.label })] })] })));
};
export default PersonBrief;
